<template>
    <div class="relative flex justify-center w-full">
        <input
            :type="inputType"
            :maxlength="maxLength"
            :placeholder="placeholder"
            v-model="answer"
            v-on:input="update()"
            class="relative w-full max-w-md bg-white border-2 border-pink focus:border-green rounded text-sm leading-none tracking-wider uppercase outline-none focus:outline-none cursor-pointer px-6 pb-6 pt-8 transition"
        />
    </div>
</template>

<script>
export default {
    props: ['placeholder', 'funtionality'],
    data() {
        return {
            answer: null,
            inputType: 'text',
            maxLength: 150,
        }
    },

    mounted() {
        if (this.funtionality === 'zip') {
            this.maxLength = 5
        }
    },

    methods: {
        update() {
            if (this.funtionality === 'zip') {
                if (this.answer.length === 5 && this.answer.match(/^[0-9]+$/) != null) {
                    this.$parent.answer = this.answer
                } else {
                    this.$parent.answer = null
                }
            } else {
                this.$parent.answer = this.answer
            }
        },
    },
}
</script>
